import API from "../../../app/api";

// ================================
// GET HOLD ORDERS
// ================================
export const getHoldOrders = async () => {
  try {
    const response = await API.get("/hold-orders");

    return response.data;
  } catch (error) {
    console.error(
      "Get Hold Orders API Error:",
      error.response?.data || error.message
    );

    throw error;
  }
};

// ================================
// MOVE HOLD ORDER
// ================================
export const moveCart = async (
  cartToken,
  type = "active"
) => {
  try {
    if (!cartToken) {
      throw new Error("Cart token is required");
    }

    const response = await API.put(
      `/cart/${encodeURIComponent(cartToken)}/move`,
      {
        type: type,
      }
    );

    console.log(
      "MOVE CART API RESPONSE:",
      response.data
    );

    return response.data;
  } catch (error) {
    console.error(
      "Move Cart API Error:",
      error.response?.data || error.message
    );

    throw error;
  }
};
